import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Params,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { CookieService } from "ngx-cookie-service";

@Injectable()
export class AuthGuard {
  constructor(
    private readonly cookieService: CookieService,
    private readonly router: Router,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    if (this.isTokenValid()) {
      return true;
    }
    // check if queryParams exists
    const index = state.url.indexOf("?");
    // remove query params from url if any
    const rootUrl = index >= 0 ? state.url.substring(0, index) : state.url;
    const queryParams: Params = { ...next.queryParams, guardUrl: rootUrl };

    this.router.navigate(["/login"], { queryParams });

    return false;
  }

  private isTokenValid(): boolean {
    const accessToken = this.cookieService.get("access_token");

    return !!accessToken;
  }
}
